"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Admin API client, contains admin API
 *
 * The version of the OpenAPI document: 0.0.0-semantic-version
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThreatMappingsApiFactory = exports.ThreatMappingsApiFp = exports.ThreatMappingsApiAxiosParamCreator = exports.QueueApi = exports.QueueApiFactory = exports.QueueApiFp = exports.QueueApiAxiosParamCreator = exports.FilterApi = exports.FilterApiFactory = exports.FilterApiFp = exports.FilterApiAxiosParamCreator = exports.ErrorApi = exports.ErrorApiFactory = exports.ErrorApiFp = exports.ErrorApiAxiosParamCreator = exports.CorsApi = exports.CorsApiFactory = exports.CorsApiFp = exports.CorsApiAxiosParamCreator = exports.ClusterApi = exports.ClusterApiFactory = exports.ClusterApiFp = exports.ClusterApiAxiosParamCreator = exports.AlertApi = exports.AlertApiFactory = exports.AlertApiFp = exports.AlertApiAxiosParamCreator = exports.UnauthorizedErrorAllOfErrorEnum = exports.UnauthorizedErrorErrorEnum = exports.NotFoundErrorAllOfErrorEnum = exports.NotFoundErrorErrorEnum = exports.InvalidRequestErrorAllOfErrorEnum = exports.InvalidRequestErrorErrorEnum = exports.InvalidQueueRequestErrorAllOfErrorEnum = exports.InvalidQueueRequestErrorErrorEnum = exports.InvalidQueryRequestErrorAllOfErrorEnum = exports.InvalidQueryRequestErrorErrorEnum = exports.InvalidFilterStatisticsRequestErrorAllOfErrorEnum = exports.InvalidFilterStatisticsRequestErrorErrorEnum = exports.InvalidFilterRequestErrorAllOfErrorEnum = exports.InvalidFilterRequestErrorErrorEnum = exports.InvalidAlertIngestRequestErrorAllOfErrorEnum = exports.InvalidAlertIngestRequestErrorErrorEnum = exports.InternalErrorAllOfErrorEnum = exports.InternalErrorErrorEnum = exports.ForbiddenErrorAllOfErrorEnum = exports.ForbiddenErrorErrorEnum = exports.ExecutionStatusEnum = exports.ConflictErrorAllOfErrorEnum = exports.ConflictErrorErrorEnum = void 0;
exports.ThreatMappingsApi = void 0;
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
    * @export
    * @enum {string}
    */
var ConflictErrorErrorEnum;
(function (ConflictErrorErrorEnum) {
    ConflictErrorErrorEnum["Conflict"] = "CONFLICT";
})(ConflictErrorErrorEnum = exports.ConflictErrorErrorEnum || (exports.ConflictErrorErrorEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ConflictErrorAllOfErrorEnum;
(function (ConflictErrorAllOfErrorEnum) {
    ConflictErrorAllOfErrorEnum["Conflict"] = "CONFLICT";
})(ConflictErrorAllOfErrorEnum = exports.ConflictErrorAllOfErrorEnum || (exports.ConflictErrorAllOfErrorEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ExecutionStatusEnum;
(function (ExecutionStatusEnum) {
    ExecutionStatusEnum["Success"] = "SUCCESS";
    ExecutionStatusEnum["Failure"] = "FAILURE";
})(ExecutionStatusEnum = exports.ExecutionStatusEnum || (exports.ExecutionStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ForbiddenErrorErrorEnum;
(function (ForbiddenErrorErrorEnum) {
    ForbiddenErrorErrorEnum["ForbiddenError"] = "FORBIDDEN_ERROR";
})(ForbiddenErrorErrorEnum = exports.ForbiddenErrorErrorEnum || (exports.ForbiddenErrorErrorEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ForbiddenErrorAllOfErrorEnum;
(function (ForbiddenErrorAllOfErrorEnum) {
    ForbiddenErrorAllOfErrorEnum["ForbiddenError"] = "FORBIDDEN_ERROR";
})(ForbiddenErrorAllOfErrorEnum = exports.ForbiddenErrorAllOfErrorEnum || (exports.ForbiddenErrorAllOfErrorEnum = {}));
/**
    * @export
    * @enum {string}
    */
var InternalErrorErrorEnum;
(function (InternalErrorErrorEnum) {
    InternalErrorErrorEnum["InternalServerError"] = "INTERNAL_SERVER_ERROR";
})(InternalErrorErrorEnum = exports.InternalErrorErrorEnum || (exports.InternalErrorErrorEnum = {}));
/**
    * @export
    * @enum {string}
    */
var InternalErrorAllOfErrorEnum;
(function (InternalErrorAllOfErrorEnum) {
    InternalErrorAllOfErrorEnum["InternalServerError"] = "INTERNAL_SERVER_ERROR";
})(InternalErrorAllOfErrorEnum = exports.InternalErrorAllOfErrorEnum || (exports.InternalErrorAllOfErrorEnum = {}));
/**
    * @export
    * @enum {string}
    */
var InvalidAlertIngestRequestErrorErrorEnum;
(function (InvalidAlertIngestRequestErrorErrorEnum) {
    InvalidAlertIngestRequestErrorErrorEnum["AlertError"] = "INVALID_ALERT_ERROR";
    InvalidAlertIngestRequestErrorErrorEnum["RequestError"] = "INVALID_REQUEST_ERROR";
    InvalidAlertIngestRequestErrorErrorEnum["RegionError"] = "INVALID_REGION_ERROR";
})(InvalidAlertIngestRequestErrorErrorEnum = exports.InvalidAlertIngestRequestErrorErrorEnum || (exports.InvalidAlertIngestRequestErrorErrorEnum = {}));
/**
    * @export
    * @enum {string}
    */
var InvalidAlertIngestRequestErrorAllOfErrorEnum;
(function (InvalidAlertIngestRequestErrorAllOfErrorEnum) {
    InvalidAlertIngestRequestErrorAllOfErrorEnum["AlertError"] = "INVALID_ALERT_ERROR";
    InvalidAlertIngestRequestErrorAllOfErrorEnum["RequestError"] = "INVALID_REQUEST_ERROR";
    InvalidAlertIngestRequestErrorAllOfErrorEnum["RegionError"] = "INVALID_REGION_ERROR";
})(InvalidAlertIngestRequestErrorAllOfErrorEnum = exports.InvalidAlertIngestRequestErrorAllOfErrorEnum || (exports.InvalidAlertIngestRequestErrorAllOfErrorEnum = {}));
/**
    * @export
    * @enum {string}
    */
var InvalidFilterRequestErrorErrorEnum;
(function (InvalidFilterRequestErrorErrorEnum) {
    InvalidFilterRequestErrorErrorEnum["FilterError"] = "INVALID_FILTER_ERROR";
    InvalidFilterRequestErrorErrorEnum["RequestError"] = "INVALID_REQUEST_ERROR";
    InvalidFilterRequestErrorErrorEnum["RegionError"] = "INVALID_REGION_ERROR";
})(InvalidFilterRequestErrorErrorEnum = exports.InvalidFilterRequestErrorErrorEnum || (exports.InvalidFilterRequestErrorErrorEnum = {}));
/**
    * @export
    * @enum {string}
    */
var InvalidFilterRequestErrorAllOfErrorEnum;
(function (InvalidFilterRequestErrorAllOfErrorEnum) {
    InvalidFilterRequestErrorAllOfErrorEnum["FilterError"] = "INVALID_FILTER_ERROR";
    InvalidFilterRequestErrorAllOfErrorEnum["RequestError"] = "INVALID_REQUEST_ERROR";
    InvalidFilterRequestErrorAllOfErrorEnum["RegionError"] = "INVALID_REGION_ERROR";
})(InvalidFilterRequestErrorAllOfErrorEnum = exports.InvalidFilterRequestErrorAllOfErrorEnum || (exports.InvalidFilterRequestErrorAllOfErrorEnum = {}));
/**
    * @export
    * @enum {string}
    */
var InvalidFilterStatisticsRequestErrorErrorEnum;
(function (InvalidFilterStatisticsRequestErrorErrorEnum) {
    InvalidFilterStatisticsRequestErrorErrorEnum["FilterQueryTimeError"] = "INVALID_FILTER_QUERY_TIME_ERROR";
    InvalidFilterStatisticsRequestErrorErrorEnum["RegionError"] = "INVALID_REGION_ERROR";
})(InvalidFilterStatisticsRequestErrorErrorEnum = exports.InvalidFilterStatisticsRequestErrorErrorEnum || (exports.InvalidFilterStatisticsRequestErrorErrorEnum = {}));
/**
    * @export
    * @enum {string}
    */
var InvalidFilterStatisticsRequestErrorAllOfErrorEnum;
(function (InvalidFilterStatisticsRequestErrorAllOfErrorEnum) {
    InvalidFilterStatisticsRequestErrorAllOfErrorEnum["FilterQueryTimeError"] = "INVALID_FILTER_QUERY_TIME_ERROR";
    InvalidFilterStatisticsRequestErrorAllOfErrorEnum["RegionError"] = "INVALID_REGION_ERROR";
})(InvalidFilterStatisticsRequestErrorAllOfErrorEnum = exports.InvalidFilterStatisticsRequestErrorAllOfErrorEnum || (exports.InvalidFilterStatisticsRequestErrorAllOfErrorEnum = {}));
/**
    * @export
    * @enum {string}
    */
var InvalidQueryRequestErrorErrorEnum;
(function (InvalidQueryRequestErrorErrorEnum) {
    InvalidQueryRequestErrorErrorEnum["QueryError"] = "INVALID_QUERY_ERROR";
    InvalidQueryRequestErrorErrorEnum["RequestError"] = "INVALID_REQUEST_ERROR";
    InvalidQueryRequestErrorErrorEnum["RegionError"] = "INVALID_REGION_ERROR";
})(InvalidQueryRequestErrorErrorEnum = exports.InvalidQueryRequestErrorErrorEnum || (exports.InvalidQueryRequestErrorErrorEnum = {}));
/**
    * @export
    * @enum {string}
    */
var InvalidQueryRequestErrorAllOfErrorEnum;
(function (InvalidQueryRequestErrorAllOfErrorEnum) {
    InvalidQueryRequestErrorAllOfErrorEnum["QueryError"] = "INVALID_QUERY_ERROR";
    InvalidQueryRequestErrorAllOfErrorEnum["RequestError"] = "INVALID_REQUEST_ERROR";
    InvalidQueryRequestErrorAllOfErrorEnum["RegionError"] = "INVALID_REGION_ERROR";
})(InvalidQueryRequestErrorAllOfErrorEnum = exports.InvalidQueryRequestErrorAllOfErrorEnum || (exports.InvalidQueryRequestErrorAllOfErrorEnum = {}));
/**
    * @export
    * @enum {string}
    */
var InvalidQueueRequestErrorErrorEnum;
(function (InvalidQueueRequestErrorErrorEnum) {
    InvalidQueueRequestErrorErrorEnum["QueueError"] = "INVALID_QUEUE_ERROR";
    InvalidQueueRequestErrorErrorEnum["TimeoutError"] = "INVALID_TIMEOUT_ERROR";
    InvalidQueueRequestErrorErrorEnum["RequestError"] = "INVALID_REQUEST_ERROR";
    InvalidQueueRequestErrorErrorEnum["RegionError"] = "INVALID_REGION_ERROR";
})(InvalidQueueRequestErrorErrorEnum = exports.InvalidQueueRequestErrorErrorEnum || (exports.InvalidQueueRequestErrorErrorEnum = {}));
/**
    * @export
    * @enum {string}
    */
var InvalidQueueRequestErrorAllOfErrorEnum;
(function (InvalidQueueRequestErrorAllOfErrorEnum) {
    InvalidQueueRequestErrorAllOfErrorEnum["QueueError"] = "INVALID_QUEUE_ERROR";
    InvalidQueueRequestErrorAllOfErrorEnum["TimeoutError"] = "INVALID_TIMEOUT_ERROR";
    InvalidQueueRequestErrorAllOfErrorEnum["RequestError"] = "INVALID_REQUEST_ERROR";
    InvalidQueueRequestErrorAllOfErrorEnum["RegionError"] = "INVALID_REGION_ERROR";
})(InvalidQueueRequestErrorAllOfErrorEnum = exports.InvalidQueueRequestErrorAllOfErrorEnum || (exports.InvalidQueueRequestErrorAllOfErrorEnum = {}));
/**
    * @export
    * @enum {string}
    */
var InvalidRequestErrorErrorEnum;
(function (InvalidRequestErrorErrorEnum) {
    InvalidRequestErrorErrorEnum["RequestError"] = "INVALID_REQUEST_ERROR";
    InvalidRequestErrorErrorEnum["RegionError"] = "INVALID_REGION_ERROR";
})(InvalidRequestErrorErrorEnum = exports.InvalidRequestErrorErrorEnum || (exports.InvalidRequestErrorErrorEnum = {}));
/**
    * @export
    * @enum {string}
    */
var InvalidRequestErrorAllOfErrorEnum;
(function (InvalidRequestErrorAllOfErrorEnum) {
    InvalidRequestErrorAllOfErrorEnum["RequestError"] = "INVALID_REQUEST_ERROR";
    InvalidRequestErrorAllOfErrorEnum["RegionError"] = "INVALID_REGION_ERROR";
})(InvalidRequestErrorAllOfErrorEnum = exports.InvalidRequestErrorAllOfErrorEnum || (exports.InvalidRequestErrorAllOfErrorEnum = {}));
/**
    * @export
    * @enum {string}
    */
var NotFoundErrorErrorEnum;
(function (NotFoundErrorErrorEnum) {
    NotFoundErrorErrorEnum["NotFound"] = "NOT_FOUND";
})(NotFoundErrorErrorEnum = exports.NotFoundErrorErrorEnum || (exports.NotFoundErrorErrorEnum = {}));
/**
    * @export
    * @enum {string}
    */
var NotFoundErrorAllOfErrorEnum;
(function (NotFoundErrorAllOfErrorEnum) {
    NotFoundErrorAllOfErrorEnum["NotFound"] = "NOT_FOUND";
})(NotFoundErrorAllOfErrorEnum = exports.NotFoundErrorAllOfErrorEnum || (exports.NotFoundErrorAllOfErrorEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UnauthorizedErrorErrorEnum;
(function (UnauthorizedErrorErrorEnum) {
    UnauthorizedErrorErrorEnum["AuthenticationError"] = "AUTHENTICATION_ERROR";
})(UnauthorizedErrorErrorEnum = exports.UnauthorizedErrorErrorEnum || (exports.UnauthorizedErrorErrorEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UnauthorizedErrorAllOfErrorEnum;
(function (UnauthorizedErrorAllOfErrorEnum) {
    UnauthorizedErrorAllOfErrorEnum["AuthenticationError"] = "AUTHENTICATION_ERROR";
})(UnauthorizedErrorAllOfErrorEnum = exports.UnauthorizedErrorAllOfErrorEnum || (exports.UnauthorizedErrorAllOfErrorEnum = {}));
/**
 * AlertApi - axios parameter creator
 * @export
 */
var AlertApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary ingest alert records
         * @param {string} [region] Region to ingest the alert in
         * @param {AlertIngestRequest} [alertIngestRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertIngest: function (region, alertIngestRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/alert";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication RequestAuthoriserProfile required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication RequestAuthoriserProfile required
                            _a.sent();
                            if (region !== undefined) {
                                localVarQueryParameter['region'] = region;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(alertIngestRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AlertApiAxiosParamCreator = AlertApiAxiosParamCreator;
/**
 * AlertApi - functional programming interface
 * @export
 */
var AlertApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AlertApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary ingest alert records
         * @param {string} [region] Region to ingest the alert in
         * @param {AlertIngestRequest} [alertIngestRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertIngest: function (region, alertIngestRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.alertIngest(region, alertIngestRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.AlertApiFp = AlertApiFp;
/**
 * AlertApi - factory interface
 * @export
 */
var AlertApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AlertApiFp)(configuration);
    return {
        /**
         *
         * @summary ingest alert records
         * @param {string} [region] Region to ingest the alert in
         * @param {AlertIngestRequest} [alertIngestRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertIngest: function (region, alertIngestRequest, options) {
            return localVarFp.alertIngest(region, alertIngestRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AlertApiFactory = AlertApiFactory;
/**
 * AlertApi - object-oriented interface
 * @export
 * @class AlertApi
 * @extends {BaseAPI}
 */
var AlertApi = /** @class */ (function (_super) {
    __extends(AlertApi, _super);
    function AlertApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary ingest alert records
     * @param {string} [region] Region to ingest the alert in
     * @param {AlertIngestRequest} [alertIngestRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertApi
     */
    AlertApi.prototype.alertIngest = function (region, alertIngestRequest, options) {
        var _this = this;
        return (0, exports.AlertApiFp)(this.configuration).alertIngest(region, alertIngestRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AlertApi;
}(base_1.BaseAPI));
exports.AlertApi = AlertApi;
/**
 * ClusterApi - axios parameter creator
 * @export
 */
var ClusterApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Deactivate a cluster
         * @summary Deactivate a cluster
         * @param {string} clusterId GUID identifying the cluster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterDeactivate: function (clusterId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'clusterId' is not null or undefined
                            (0, common_1.assertParamExists)('clusterDeactivate', 'clusterId', clusterId);
                            localVarPath = "/cluster/{clusterId}/deactivate"
                                .replace("{" + "clusterId" + "}", encodeURIComponent(String(clusterId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication RequestAuthoriserProfile required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication RequestAuthoriserProfile required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ClusterApiAxiosParamCreator = ClusterApiAxiosParamCreator;
/**
 * ClusterApi - functional programming interface
 * @export
 */
var ClusterApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ClusterApiAxiosParamCreator)(configuration);
    return {
        /**
         * Deactivate a cluster
         * @summary Deactivate a cluster
         * @param {string} clusterId GUID identifying the cluster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterDeactivate: function (clusterId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.clusterDeactivate(clusterId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ClusterApiFp = ClusterApiFp;
/**
 * ClusterApi - factory interface
 * @export
 */
var ClusterApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ClusterApiFp)(configuration);
    return {
        /**
         * Deactivate a cluster
         * @summary Deactivate a cluster
         * @param {string} clusterId GUID identifying the cluster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterDeactivate: function (clusterId, options) {
            return localVarFp.clusterDeactivate(clusterId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ClusterApiFactory = ClusterApiFactory;
/**
 * ClusterApi - object-oriented interface
 * @export
 * @class ClusterApi
 * @extends {BaseAPI}
 */
var ClusterApi = /** @class */ (function (_super) {
    __extends(ClusterApi, _super);
    function ClusterApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Deactivate a cluster
     * @summary Deactivate a cluster
     * @param {string} clusterId GUID identifying the cluster
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterApi
     */
    ClusterApi.prototype.clusterDeactivate = function (clusterId, options) {
        var _this = this;
        return (0, exports.ClusterApiFp)(this.configuration).clusterDeactivate(clusterId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ClusterApi;
}(base_1.BaseAPI));
exports.ClusterApi = ClusterApi;
/**
 * CorsApi - axios parameter creator
 * @export
 */
var CorsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/alert";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} queueType Name of the queue to query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deadLetterQueueTypeDeleteOptions: function (queueType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'queueType' is not null or undefined
                    (0, common_1.assertParamExists)('deadLetterQueueTypeDeleteOptions', 'queueType', queueType);
                    localVarPath = "/deadLetter/{queueType}/delete"
                        .replace("{" + "queueType" + "}", encodeURIComponent(String(queueType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} queueType Name of the queue to query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deadLetterQueueTypeOptions: function (queueType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'queueType' is not null or undefined
                    (0, common_1.assertParamExists)('deadLetterQueueTypeOptions', 'queueType', queueType);
                    localVarPath = "/deadLetter/{queueType}"
                        .replace("{" + "queueType" + "}", encodeURIComponent(String(queueType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorDeleteOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/error/delete";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/error";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} filterId ID for the filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterFilterIdOptions: function (filterId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'filterId' is not null or undefined
                    (0, common_1.assertParamExists)('filterFilterIdOptions', 'filterId', filterId);
                    localVarPath = "/filter/{filterId}"
                        .replace("{" + "filterId" + "}", encodeURIComponent(String(filterId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/filter";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} organisationId Query statistics for all filters for a specific organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterOrganisationOrganisationIdOptions: function (organisationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'organisationId' is not null or undefined
                    (0, common_1.assertParamExists)('filterOrganisationOrganisationIdOptions', 'organisationId', organisationId);
                    localVarPath = "/filter/organisation/{organisationId}"
                        .replace("{" + "organisationId" + "}", encodeURIComponent(String(organisationId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threatMappingsOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/threatMappings";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'OPTIONS' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CorsApiAxiosParamCreator = CorsApiAxiosParamCreator;
/**
 * CorsApi - functional programming interface
 * @export
 */
var CorsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CorsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertOptions: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.alertOptions(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} queueType Name of the queue to query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deadLetterQueueTypeDeleteOptions: function (queueType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deadLetterQueueTypeDeleteOptions(queueType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} queueType Name of the queue to query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deadLetterQueueTypeOptions: function (queueType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deadLetterQueueTypeOptions(queueType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorDeleteOptions: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.errorDeleteOptions(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorOptions: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.errorOptions(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} filterId ID for the filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterFilterIdOptions: function (filterId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.filterFilterIdOptions(filterId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterOptions: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.filterOptions(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} organisationId Query statistics for all filters for a specific organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterOrganisationOrganisationIdOptions: function (organisationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.filterOrganisationOrganisationIdOptions(organisationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threatMappingsOptions: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.threatMappingsOptions(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CorsApiFp = CorsApiFp;
/**
 * CorsApi - factory interface
 * @export
 */
var CorsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CorsApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertOptions: function (options) {
            return localVarFp.alertOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} queueType Name of the queue to query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deadLetterQueueTypeDeleteOptions: function (queueType, options) {
            return localVarFp.deadLetterQueueTypeDeleteOptions(queueType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} queueType Name of the queue to query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deadLetterQueueTypeOptions: function (queueType, options) {
            return localVarFp.deadLetterQueueTypeOptions(queueType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorDeleteOptions: function (options) {
            return localVarFp.errorDeleteOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorOptions: function (options) {
            return localVarFp.errorOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} filterId ID for the filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterFilterIdOptions: function (filterId, options) {
            return localVarFp.filterFilterIdOptions(filterId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterOptions: function (options) {
            return localVarFp.filterOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} organisationId Query statistics for all filters for a specific organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterOrganisationOrganisationIdOptions: function (organisationId, options) {
            return localVarFp.filterOrganisationOrganisationIdOptions(organisationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threatMappingsOptions: function (options) {
            return localVarFp.threatMappingsOptions(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CorsApiFactory = CorsApiFactory;
/**
 * CorsApi - object-oriented interface
 * @export
 * @class CorsApi
 * @extends {BaseAPI}
 */
var CorsApi = /** @class */ (function (_super) {
    __extends(CorsApi, _super);
    function CorsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorsApi
     */
    CorsApi.prototype.alertOptions = function (options) {
        var _this = this;
        return (0, exports.CorsApiFp)(this.configuration).alertOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} queueType Name of the queue to query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorsApi
     */
    CorsApi.prototype.deadLetterQueueTypeDeleteOptions = function (queueType, options) {
        var _this = this;
        return (0, exports.CorsApiFp)(this.configuration).deadLetterQueueTypeDeleteOptions(queueType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} queueType Name of the queue to query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorsApi
     */
    CorsApi.prototype.deadLetterQueueTypeOptions = function (queueType, options) {
        var _this = this;
        return (0, exports.CorsApiFp)(this.configuration).deadLetterQueueTypeOptions(queueType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorsApi
     */
    CorsApi.prototype.errorDeleteOptions = function (options) {
        var _this = this;
        return (0, exports.CorsApiFp)(this.configuration).errorDeleteOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorsApi
     */
    CorsApi.prototype.errorOptions = function (options) {
        var _this = this;
        return (0, exports.CorsApiFp)(this.configuration).errorOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} filterId ID for the filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorsApi
     */
    CorsApi.prototype.filterFilterIdOptions = function (filterId, options) {
        var _this = this;
        return (0, exports.CorsApiFp)(this.configuration).filterFilterIdOptions(filterId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorsApi
     */
    CorsApi.prototype.filterOptions = function (options) {
        var _this = this;
        return (0, exports.CorsApiFp)(this.configuration).filterOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} organisationId Query statistics for all filters for a specific organisation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorsApi
     */
    CorsApi.prototype.filterOrganisationOrganisationIdOptions = function (organisationId, options) {
        var _this = this;
        return (0, exports.CorsApiFp)(this.configuration).filterOrganisationOrganisationIdOptions(organisationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorsApi
     */
    CorsApi.prototype.threatMappingsOptions = function (options) {
        var _this = this;
        return (0, exports.CorsApiFp)(this.configuration).threatMappingsOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CorsApi;
}(base_1.BaseAPI));
exports.CorsApi = CorsApi;
/**
 * ErrorApi - axios parameter creator
 * @export
 */
var ErrorApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Delete error records
         * @param {string} [region] Region in which the documentDB instance lives
         * @param {DocumentFilterRequest} [documentFilterRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorDelete: function (region, documentFilterRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/error/delete";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication RequestAuthoriserProfile required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication RequestAuthoriserProfile required
                            _a.sent();
                            if (region !== undefined) {
                                localVarQueryParameter['region'] = region;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(documentFilterRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary fetch error documents
         * @param {string} [region] Region in which the error database instance lives
         * @param {number} [pageStart] This is the page start number from where the query will be performed
         * @param {number} [pageSize] Limit of the page size to receive
         * @param {DocumentQueryRequest} [documentQueryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorQuery: function (region, pageStart, pageSize, documentQueryRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/error";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication RequestAuthoriserProfile required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication RequestAuthoriserProfile required
                            _a.sent();
                            if (region !== undefined) {
                                localVarQueryParameter['region'] = region;
                            }
                            if (pageStart !== undefined) {
                                localVarQueryParameter['pageStart'] = pageStart;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(documentQueryRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary update error records
         * @param {string} [region] Region in which the error database instance lives
         * @param {DocumentFilterRequest} [documentFilterRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorUpdate: function (region, documentFilterRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/error";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication RequestAuthoriserProfile required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication RequestAuthoriserProfile required
                            _a.sent();
                            if (region !== undefined) {
                                localVarQueryParameter['region'] = region;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(documentFilterRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ErrorApiAxiosParamCreator = ErrorApiAxiosParamCreator;
/**
 * ErrorApi - functional programming interface
 * @export
 */
var ErrorApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ErrorApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Delete error records
         * @param {string} [region] Region in which the documentDB instance lives
         * @param {DocumentFilterRequest} [documentFilterRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorDelete: function (region, documentFilterRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.errorDelete(region, documentFilterRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary fetch error documents
         * @param {string} [region] Region in which the error database instance lives
         * @param {number} [pageStart] This is the page start number from where the query will be performed
         * @param {number} [pageSize] Limit of the page size to receive
         * @param {DocumentQueryRequest} [documentQueryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorQuery: function (region, pageStart, pageSize, documentQueryRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.errorQuery(region, pageStart, pageSize, documentQueryRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary update error records
         * @param {string} [region] Region in which the error database instance lives
         * @param {DocumentFilterRequest} [documentFilterRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorUpdate: function (region, documentFilterRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.errorUpdate(region, documentFilterRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ErrorApiFp = ErrorApiFp;
/**
 * ErrorApi - factory interface
 * @export
 */
var ErrorApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ErrorApiFp)(configuration);
    return {
        /**
         *
         * @summary Delete error records
         * @param {string} [region] Region in which the documentDB instance lives
         * @param {DocumentFilterRequest} [documentFilterRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorDelete: function (region, documentFilterRequest, options) {
            return localVarFp.errorDelete(region, documentFilterRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary fetch error documents
         * @param {string} [region] Region in which the error database instance lives
         * @param {number} [pageStart] This is the page start number from where the query will be performed
         * @param {number} [pageSize] Limit of the page size to receive
         * @param {DocumentQueryRequest} [documentQueryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorQuery: function (region, pageStart, pageSize, documentQueryRequest, options) {
            return localVarFp.errorQuery(region, pageStart, pageSize, documentQueryRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary update error records
         * @param {string} [region] Region in which the error database instance lives
         * @param {DocumentFilterRequest} [documentFilterRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorUpdate: function (region, documentFilterRequest, options) {
            return localVarFp.errorUpdate(region, documentFilterRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ErrorApiFactory = ErrorApiFactory;
/**
 * ErrorApi - object-oriented interface
 * @export
 * @class ErrorApi
 * @extends {BaseAPI}
 */
var ErrorApi = /** @class */ (function (_super) {
    __extends(ErrorApi, _super);
    function ErrorApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Delete error records
     * @param {string} [region] Region in which the documentDB instance lives
     * @param {DocumentFilterRequest} [documentFilterRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ErrorApi
     */
    ErrorApi.prototype.errorDelete = function (region, documentFilterRequest, options) {
        var _this = this;
        return (0, exports.ErrorApiFp)(this.configuration).errorDelete(region, documentFilterRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary fetch error documents
     * @param {string} [region] Region in which the error database instance lives
     * @param {number} [pageStart] This is the page start number from where the query will be performed
     * @param {number} [pageSize] Limit of the page size to receive
     * @param {DocumentQueryRequest} [documentQueryRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ErrorApi
     */
    ErrorApi.prototype.errorQuery = function (region, pageStart, pageSize, documentQueryRequest, options) {
        var _this = this;
        return (0, exports.ErrorApiFp)(this.configuration).errorQuery(region, pageStart, pageSize, documentQueryRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary update error records
     * @param {string} [region] Region in which the error database instance lives
     * @param {DocumentFilterRequest} [documentFilterRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ErrorApi
     */
    ErrorApi.prototype.errorUpdate = function (region, documentFilterRequest, options) {
        var _this = this;
        return (0, exports.ErrorApiFp)(this.configuration).errorUpdate(region, documentFilterRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ErrorApi;
}(base_1.BaseAPI));
exports.ErrorApi = ErrorApi;
/**
 * FilterApi - axios parameter creator
 * @export
 */
var FilterApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Query statistics for a single filter by ID
         * @param {string} filterId ID for the filter
         * @param {string} [region] Region to query filters
         * @param {number} [days] The number of days to check data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilter: function (filterId, region, days, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'filterId' is not null or undefined
                            (0, common_1.assertParamExists)('getFilter', 'filterId', filterId);
                            localVarPath = "/filter/{filterId}"
                                .replace("{" + "filterId" + "}", encodeURIComponent(String(filterId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication RequestAuthoriserProfile required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication RequestAuthoriserProfile required
                            _a.sent();
                            if (region !== undefined) {
                                localVarQueryParameter['region'] = region;
                            }
                            if (days !== undefined) {
                                localVarQueryParameter['days'] = days;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Query statistics for all filters
         * @param {string} [region] Region to query filters
         * @param {number} [days] The number of days to check data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFilters: function (region, days, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/filter";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication RequestAuthoriserProfile required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication RequestAuthoriserProfile required
                            _a.sent();
                            if (region !== undefined) {
                                localVarQueryParameter['region'] = region;
                            }
                            if (days !== undefined) {
                                localVarQueryParameter['days'] = days;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Query statistics for filters by ID
         * @param {string} organisationId Query statistics for all filters for a specific organisation
         * @param {string} [region] Region to query filters
         * @param {number} [days] The number of days to check data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganisationFilters: function (organisationId, region, days, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'organisationId' is not null or undefined
                            (0, common_1.assertParamExists)('listOrganisationFilters', 'organisationId', organisationId);
                            localVarPath = "/filter/organisation/{organisationId}"
                                .replace("{" + "organisationId" + "}", encodeURIComponent(String(organisationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication RequestAuthoriserProfile required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication RequestAuthoriserProfile required
                            _a.sent();
                            if (region !== undefined) {
                                localVarQueryParameter['region'] = region;
                            }
                            if (days !== undefined) {
                                localVarQueryParameter['days'] = days;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.FilterApiAxiosParamCreator = FilterApiAxiosParamCreator;
/**
 * FilterApi - functional programming interface
 * @export
 */
var FilterApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FilterApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Query statistics for a single filter by ID
         * @param {string} filterId ID for the filter
         * @param {string} [region] Region to query filters
         * @param {number} [days] The number of days to check data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilter: function (filterId, region, days, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFilter(filterId, region, days, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Query statistics for all filters
         * @param {string} [region] Region to query filters
         * @param {number} [days] The number of days to check data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFilters: function (region, days, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listFilters(region, days, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Query statistics for filters by ID
         * @param {string} organisationId Query statistics for all filters for a specific organisation
         * @param {string} [region] Region to query filters
         * @param {number} [days] The number of days to check data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganisationFilters: function (organisationId, region, days, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listOrganisationFilters(organisationId, region, days, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.FilterApiFp = FilterApiFp;
/**
 * FilterApi - factory interface
 * @export
 */
var FilterApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FilterApiFp)(configuration);
    return {
        /**
         *
         * @summary Query statistics for a single filter by ID
         * @param {string} filterId ID for the filter
         * @param {string} [region] Region to query filters
         * @param {number} [days] The number of days to check data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilter: function (filterId, region, days, options) {
            return localVarFp.getFilter(filterId, region, days, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Query statistics for all filters
         * @param {string} [region] Region to query filters
         * @param {number} [days] The number of days to check data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFilters: function (region, days, options) {
            return localVarFp.listFilters(region, days, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Query statistics for filters by ID
         * @param {string} organisationId Query statistics for all filters for a specific organisation
         * @param {string} [region] Region to query filters
         * @param {number} [days] The number of days to check data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganisationFilters: function (organisationId, region, days, options) {
            return localVarFp.listOrganisationFilters(organisationId, region, days, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FilterApiFactory = FilterApiFactory;
/**
 * FilterApi - object-oriented interface
 * @export
 * @class FilterApi
 * @extends {BaseAPI}
 */
var FilterApi = /** @class */ (function (_super) {
    __extends(FilterApi, _super);
    function FilterApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Query statistics for a single filter by ID
     * @param {string} filterId ID for the filter
     * @param {string} [region] Region to query filters
     * @param {number} [days] The number of days to check data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterApi
     */
    FilterApi.prototype.getFilter = function (filterId, region, days, options) {
        var _this = this;
        return (0, exports.FilterApiFp)(this.configuration).getFilter(filterId, region, days, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Query statistics for all filters
     * @param {string} [region] Region to query filters
     * @param {number} [days] The number of days to check data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterApi
     */
    FilterApi.prototype.listFilters = function (region, days, options) {
        var _this = this;
        return (0, exports.FilterApiFp)(this.configuration).listFilters(region, days, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Query statistics for filters by ID
     * @param {string} organisationId Query statistics for all filters for a specific organisation
     * @param {string} [region] Region to query filters
     * @param {number} [days] The number of days to check data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterApi
     */
    FilterApi.prototype.listOrganisationFilters = function (organisationId, region, days, options) {
        var _this = this;
        return (0, exports.FilterApiFp)(this.configuration).listOrganisationFilters(organisationId, region, days, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FilterApi;
}(base_1.BaseAPI));
exports.FilterApi = FilterApi;
/**
 * QueueApi - axios parameter creator
 * @export
 */
var QueueApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Delete specified items in the dead-letter queue for a specified queue
         * @summary Delete dead-letter queue items
         * @param {string} queueType Name of the queue to query
         * @param {string} [region] Region in which the queue lives
         * @param {QueueItemsRequest} [queueItemsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deadLetterDelete: function (queueType, region, queueItemsRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'queueType' is not null or undefined
                            (0, common_1.assertParamExists)('deadLetterDelete', 'queueType', queueType);
                            localVarPath = "/deadLetter/{queueType}/delete"
                                .replace("{" + "queueType" + "}", encodeURIComponent(String(queueType)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication RequestAuthoriserProfile required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication RequestAuthoriserProfile required
                            _a.sent();
                            if (region !== undefined) {
                                localVarQueryParameter['region'] = region;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(queueItemsRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Find items in the dead-letter queue for a specified queue
         * @summary Query dead-letter queue
         * @param {string} queueType Name of the queue to query
         * @param {number} [timeout] Maximum amount of time to collect queue items in milliseconds
         * @param {string} [region] Region in which the queue lives
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deadLetterQuery: function (queueType, timeout, region, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'queueType' is not null or undefined
                            (0, common_1.assertParamExists)('deadLetterQuery', 'queueType', queueType);
                            localVarPath = "/deadLetter/{queueType}"
                                .replace("{" + "queueType" + "}", encodeURIComponent(String(queueType)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication RequestAuthoriserProfile required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication RequestAuthoriserProfile required
                            _a.sent();
                            if (timeout !== undefined) {
                                localVarQueryParameter['timeout'] = timeout;
                            }
                            if (region !== undefined) {
                                localVarQueryParameter['region'] = region;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Redrive the dead-letter queue for a specified queue
         * @summary Redrive dead-letter queue
         * @param {string} queueType Name of the queue to query
         * @param {string} [region] Region in which the queue lives
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deadLetterRedrive: function (queueType, region, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'queueType' is not null or undefined
                            (0, common_1.assertParamExists)('deadLetterRedrive', 'queueType', queueType);
                            localVarPath = "/deadLetter/{queueType}"
                                .replace("{" + "queueType" + "}", encodeURIComponent(String(queueType)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication RequestAuthoriserProfile required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication RequestAuthoriserProfile required
                            _a.sent();
                            if (region !== undefined) {
                                localVarQueryParameter['region'] = region;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.QueueApiAxiosParamCreator = QueueApiAxiosParamCreator;
/**
 * QueueApi - functional programming interface
 * @export
 */
var QueueApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.QueueApiAxiosParamCreator)(configuration);
    return {
        /**
         * Delete specified items in the dead-letter queue for a specified queue
         * @summary Delete dead-letter queue items
         * @param {string} queueType Name of the queue to query
         * @param {string} [region] Region in which the queue lives
         * @param {QueueItemsRequest} [queueItemsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deadLetterDelete: function (queueType, region, queueItemsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deadLetterDelete(queueType, region, queueItemsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Find items in the dead-letter queue for a specified queue
         * @summary Query dead-letter queue
         * @param {string} queueType Name of the queue to query
         * @param {number} [timeout] Maximum amount of time to collect queue items in milliseconds
         * @param {string} [region] Region in which the queue lives
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deadLetterQuery: function (queueType, timeout, region, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deadLetterQuery(queueType, timeout, region, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Redrive the dead-letter queue for a specified queue
         * @summary Redrive dead-letter queue
         * @param {string} queueType Name of the queue to query
         * @param {string} [region] Region in which the queue lives
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deadLetterRedrive: function (queueType, region, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deadLetterRedrive(queueType, region, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.QueueApiFp = QueueApiFp;
/**
 * QueueApi - factory interface
 * @export
 */
var QueueApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.QueueApiFp)(configuration);
    return {
        /**
         * Delete specified items in the dead-letter queue for a specified queue
         * @summary Delete dead-letter queue items
         * @param {string} queueType Name of the queue to query
         * @param {string} [region] Region in which the queue lives
         * @param {QueueItemsRequest} [queueItemsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deadLetterDelete: function (queueType, region, queueItemsRequest, options) {
            return localVarFp.deadLetterDelete(queueType, region, queueItemsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Find items in the dead-letter queue for a specified queue
         * @summary Query dead-letter queue
         * @param {string} queueType Name of the queue to query
         * @param {number} [timeout] Maximum amount of time to collect queue items in milliseconds
         * @param {string} [region] Region in which the queue lives
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deadLetterQuery: function (queueType, timeout, region, options) {
            return localVarFp.deadLetterQuery(queueType, timeout, region, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Redrive the dead-letter queue for a specified queue
         * @summary Redrive dead-letter queue
         * @param {string} queueType Name of the queue to query
         * @param {string} [region] Region in which the queue lives
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deadLetterRedrive: function (queueType, region, options) {
            return localVarFp.deadLetterRedrive(queueType, region, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.QueueApiFactory = QueueApiFactory;
/**
 * QueueApi - object-oriented interface
 * @export
 * @class QueueApi
 * @extends {BaseAPI}
 */
var QueueApi = /** @class */ (function (_super) {
    __extends(QueueApi, _super);
    function QueueApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Delete specified items in the dead-letter queue for a specified queue
     * @summary Delete dead-letter queue items
     * @param {string} queueType Name of the queue to query
     * @param {string} [region] Region in which the queue lives
     * @param {QueueItemsRequest} [queueItemsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.deadLetterDelete = function (queueType, region, queueItemsRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).deadLetterDelete(queueType, region, queueItemsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Find items in the dead-letter queue for a specified queue
     * @summary Query dead-letter queue
     * @param {string} queueType Name of the queue to query
     * @param {number} [timeout] Maximum amount of time to collect queue items in milliseconds
     * @param {string} [region] Region in which the queue lives
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.deadLetterQuery = function (queueType, timeout, region, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).deadLetterQuery(queueType, timeout, region, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Redrive the dead-letter queue for a specified queue
     * @summary Redrive dead-letter queue
     * @param {string} queueType Name of the queue to query
     * @param {string} [region] Region in which the queue lives
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.deadLetterRedrive = function (queueType, region, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).deadLetterRedrive(queueType, region, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return QueueApi;
}(base_1.BaseAPI));
exports.QueueApi = QueueApi;
/**
 * ThreatMappingsApi - axios parameter creator
 * @export
 */
var ThreatMappingsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Fetch outstanding threat mappings
         * @param {number} pageSize Limit on the number of items to fetch from each region
         * @param {string} [region] Region from which to fetch threat mappings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchThreatMappings: function (pageSize, region, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'pageSize' is not null or undefined
                            (0, common_1.assertParamExists)('fetchThreatMappings', 'pageSize', pageSize);
                            localVarPath = "/threatMappings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication RequestAuthoriserProfile required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication RequestAuthoriserProfile required
                            _a.sent();
                            if (region !== undefined) {
                                localVarQueryParameter['region'] = region;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ThreatMappingsApiAxiosParamCreator = ThreatMappingsApiAxiosParamCreator;
/**
 * ThreatMappingsApi - functional programming interface
 * @export
 */
var ThreatMappingsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ThreatMappingsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Fetch outstanding threat mappings
         * @param {number} pageSize Limit on the number of items to fetch from each region
         * @param {string} [region] Region from which to fetch threat mappings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchThreatMappings: function (pageSize, region, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fetchThreatMappings(pageSize, region, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ThreatMappingsApiFp = ThreatMappingsApiFp;
/**
 * ThreatMappingsApi - factory interface
 * @export
 */
var ThreatMappingsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ThreatMappingsApiFp)(configuration);
    return {
        /**
         *
         * @summary Fetch outstanding threat mappings
         * @param {number} pageSize Limit on the number of items to fetch from each region
         * @param {string} [region] Region from which to fetch threat mappings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchThreatMappings: function (pageSize, region, options) {
            return localVarFp.fetchThreatMappings(pageSize, region, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ThreatMappingsApiFactory = ThreatMappingsApiFactory;
/**
 * ThreatMappingsApi - object-oriented interface
 * @export
 * @class ThreatMappingsApi
 * @extends {BaseAPI}
 */
var ThreatMappingsApi = /** @class */ (function (_super) {
    __extends(ThreatMappingsApi, _super);
    function ThreatMappingsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Fetch outstanding threat mappings
     * @param {number} pageSize Limit on the number of items to fetch from each region
     * @param {string} [region] Region from which to fetch threat mappings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThreatMappingsApi
     */
    ThreatMappingsApi.prototype.fetchThreatMappings = function (pageSize, region, options) {
        var _this = this;
        return (0, exports.ThreatMappingsApiFp)(this.configuration).fetchThreatMappings(pageSize, region, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ThreatMappingsApi;
}(base_1.BaseAPI));
exports.ThreatMappingsApi = ThreatMappingsApi;
//# sourceMappingURL=api.js.map